import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonRemove = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_325_1352",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_325_1352)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15.6004 11.3998V9.5998H21.6004V11.3998H15.6004ZM9.60039 11.9998C8.60039 11.9998 7.75039 11.6498 7.05039 10.9498C6.35039 10.2498 6.00039 9.3998 6.00039 8.3998C6.00039 7.3998 6.35039 6.5498 7.05039 5.8498C7.75039 5.1498 8.60039 4.7998 9.60039 4.7998C10.6004 4.7998 11.4504 5.1498 12.1504 5.8498C12.8504 6.5498 13.2004 7.3998 13.2004 8.3998C13.2004 9.3998 12.8504 10.2498 12.1504 10.9498C11.4504 11.6498 10.6004 11.9998 9.60039 11.9998ZM2.40039 19.1998V16.8998C2.40039 16.4701 2.50456 16.0752 2.71289 15.7151C2.92122 15.3549 3.20872 15.0665 3.57539 14.8498C4.49206 14.3165 5.45872 13.9081 6.47539 13.6248C7.49206 13.3415 8.53372 13.1998 9.60039 13.1998C10.6671 13.1998 11.7087 13.3415 12.7254 13.6248C13.7421 13.9081 14.7087 14.3165 15.6254 14.8498C15.9921 15.0665 16.2796 15.3549 16.4879 15.7151C16.6962 16.0752 16.8004 16.4701 16.8004 16.8998V19.1998H2.40039ZM4.20039 17.3998H15.0004V16.8998C15.0004 16.792 14.9751 16.694 14.9246 16.6058C14.8743 16.5175 14.8079 16.4488 14.7254 16.3998C13.9421 15.9498 13.1171 15.604 12.2504 15.3623C11.3837 15.1206 10.5004 14.9998 9.60039 14.9998C8.70039 14.9998 7.81706 15.1206 6.95039 15.3623C6.08372 15.604 5.25872 15.9498 4.47539 16.3998C4.39289 16.4488 4.32639 16.5175 4.27589 16.6058C4.22556 16.694 4.20039 16.792 4.20039 16.8998V17.3998ZM9.60564 10.1998C10.1021 10.1998 10.5254 10.0231 10.8754 9.66955C11.2254 9.31605 11.4004 8.89105 11.4004 8.39455C11.4004 7.89805 11.2236 7.4748 10.8701 7.1248C10.5166 6.7748 10.0916 6.5998 9.59514 6.5998C9.09864 6.5998 8.67539 6.77656 8.32539 7.13006C7.97539 7.48356 7.80039 7.90856 7.80039 8.40506C7.80039 8.90156 7.97714 9.3248 8.33064 9.6748C8.68414 10.0248 9.10914 10.1998 9.60564 10.1998Z",
				fill: "#EF476F"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgPersonRemove);
export { ForwardRef as ReactComponent };
